import { createPinia as createPiniaOrigin } from 'pinia';
import { PiniaLogger } from 'pinia-logger';

import { LoadingHandlerPiniaPlugin, TranslatableErrorHandlerPiniaPlugin } from './plugins';

export { default as useAuth } from './auth';
export { default as useCcpStore } from './ccp';
export { default as useFiltersStore } from './filters';
export { default as useUsageReportingStore } from './reportingUsage';
export { default as useEnvironmentsStore } from './environments';
export { default as useAccountsStore } from './accounts';
export { usePermissionsStore } from './permissions';

function createPinia() {
  return createPiniaOrigin()
    .use(PiniaLogger({
      expanded: false,
      disabled: process.env.NODE_ENV === 'production',
    }))
    .use(LoadingHandlerPiniaPlugin)
    .use(TranslatableErrorHandlerPiniaPlugin);
}

export default createPinia;
